import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import Footer from "./components/Footer";

export default function ReqSuccess() {
	const navigate = useNavigate();

	useEffect(() => {
		const timer = setTimeout(() => {
			navigate("/view-scanning-requests");
		}, 3000);
		return () => clearTimeout(timer);
	}, [navigate]);

	return (
		<div className=" flex flex-col bg-digitalWhite min-h-[72dvh] items-center justify-center">
			{/* Main content */}
			<main className=" flex py-8 justify-center">
				<div className="w-full max-w-2xl  bg-white rounded shadow p-8 flex flex-col items-center gap-4">
					<p className="text-center text-lg font-semibold">
						Your request has been submitted. A receipt of your request has been automatically
						downloaded.
					</p>
					<p className="text-center text-lg font-semibold">
						If you have not already, please drop off your exams at GSB 2-40. Please bring your
						receipt with you.
					</p>
					<p className="text-center text-lg font-semibold">Redirecting...</p>
					<CircularProgress className="mt-4" />
				</div>
			</main>
		</div>
	);
}
